<template>
    <div class="item mb-2" @click="onClick" :class="{current: isCurrent}">
        <div class="item-title d-flex justify-content-end">
            <span class="badge badge-purple" v-if="hasStatusSent">{{ formattedSentAt }}</span>
            <el-popover
                v-if="hasStatusError"
                placement="left-start"
                trigger="hover"
                width="300"
            >
                <span class="badge badge-danger" slot="reference">ERROR</span>
                <template v-slot:default>
                    <div class="text-break">
                        <div class="text-pre-wrap"><strong>Code:</strong> {{ errorCode }}</div>
                        <div class="w-100"><strong>Description:</strong> <span>{{ errorDescription }}</span></div>
                    </div>
                </template>
            </el-popover>
            <span class="badge badge-warning" v-if="hasStatusQueued">QUEUED</span>
        </div>
        <div class="contact" v-text="contactLine"></div>
        <div class="outgoing-number" v-text="outgoingNumberLine"></div>
    </div>
</template>

<script>
  import {isFilled} from "../../../../helpers";

  export default {
    props: {
      item: null,
      isCurrent: null,
      select: null,
    },

    data() {
      return {
        statuses: config('constants.message.statuses'),
      };
    },

    computed: {
      /**
       * @return {Object|null}
       */
      contact() {
        return _.get(this.item, 'conversation.contact', null);
      },

      /**
       * @return {Object|null}
       */
      outgoingNumber() {
        return _.get(this.item, 'conversation.outgoing_number', null);
      },

      /**
       * @return {string}
       */
      contactLine() {
        const {full_name, filemaker_id, phone_number} = this.contact || {};

        return `${filemaker_id} ${full_name}`
          + (isFilled(phone_number) ? ` (${phone_number})` : '');
      },

      /**
       * @return {string}
       */
      outgoingNumberLine() {
        const {title, phone_number} = this.outgoingNumber || {};
        return `${title} (${phone_number})`;
      },

      /**
       * @return {string}
       */
      formattedSentAt() {
        const sentAt = _.get(this.item, 'sent_at', '');
        if (!sentAt) {
          return '';
        }

        return moment(sentAt.iso).format('ddd, MMM D, YYYY ') + sentAt.time
      },

      /**
       * @return {boolean}
       */
      hasStatusSent() {
        return this.statuses.sent === _.get(this.item, 'status');
      },

      /**
       * @return {boolean}
       */
      hasStatusError() {
        return this.statuses.error === _.get(this.item, 'status');
      },

      /**
       * @return {boolean}
       */
      hasStatusQueued() {
        return this.statuses.queued === _.get(this.item, 'status');
      },

      /**
       * @return {string}
       */
      formatSentAt() {
        const sentAt = _.get(this.item, 'sent_at', '');
        if (!sentAt) {
          return '';
        }

        return moment(sentAt.iso).format('ddd, MMM D, YYYY ') + sentAt.time
      },

      /**
       * @return {string}
       */
      errorCode() {
        return _.get(this.item, 'error_code', '');
      },

      /**
       * @return {string}
       */
      errorDescription() {
        return _.get(this.item, 'error_code_as_text', '');
      },
    },

    methods: {
      onClick() {
        this.select(this.item);
      }
    },
  }
</script>
